module.exports = __webpack_public_path__ + "static/img/solution-enabler.88a21b4d.png";